import CompanyTableContainer from './CompanyTableContainer';

export default CompanyTableContainer;